import React from 'react';

import LoadingSpinner from '@xingternal/malt-loading-spinner';

import styles from './contact.css';

const Loading = () => (
  <section className={styles.spinner}>
    <LoadingSpinner size="60px" />
  </section>
);

export default Loading;
